// Turns legacy solution-page HTML (h2 chapters, <br>-separated bold blocks, • bullets, numbered steps, img+h3 guide cards)
// into structured chapters. Copy stays verbatim — only the layout changes.
const strip = (html) => html.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
const BULLET = /^\s*(?:&bull;|•|·)\s*/;
const NUMBERED = /^\s*(\d+)\.\s+/;

const isBullet = (l) => BULLET.test(strip(l));
const isNumbered = (l) => NUMBERED.test(strip(l));
const titleOf = (l) => {
  const m = l.match(/^\s*<strong>(.*?)<\/strong>\s*$/i);
  const t = strip(m ? m[1] : l);
  if (t.length > (m ? 90 : 70) || /[.:;!?]$/.test(t) || /<a\b/i.test(l)) return null;
  return m || t.length <= 70 ? t : null;
};
const unbullet = (l) => l.replace(/^(\s*<[^>]+>)*\s*(?:&bull;|•|·)\s*/, "$1");
const unnumber = (l) => {
  const body = l.replace(/^(\s*<[^>]+>)*\s*\d+\.\s*/, "$1");
  const m = body.match(/^\s*<strong>(.*?)<\/strong>\s*:?\s*(.*)$/i) || body.match(/^([^<]{3,60}?):\s*(.*)$/);
  return m ? { title: strip(m[1]), text: m[2] } : { title: "", text: body };
};

// Walk the section line by line: bold/short lines open a card, • lines are bullets, "1." lines are steps.
function parseLines(html) {
  const lines = html.split(/<br\s*\/?>/i).map((l) => l.trim()).filter((l) => strip(l) || /<img\b/i.test(l));
  const lead = [], cards = [], steps = [];
  let card = null;
  const target = () => card || { bullets: [], steps, texts: lead };
  lines.forEach((l, i) => {
    const img = l.match(/^<img\b[^>]*\bsrc="([^"]+)"/i);
    if (img) { if (card) card.icon = img[1]; return; }
    if (isBullet(l)) { const t = target(); t.bullets.push(unbullet(l)); if (!card) lead.push({ bullet: unbullet(l) }); return; }
    if (isNumbered(l)) { const t = target(); t.steps.push(unnumber(l)); return; }
    const title = titleOf(l);
    if (title && i < lines.length - 1) { card = { title, texts: [], bullets: [], steps: [] }; cards.push(card); return; }
    if (card) card.texts.push(l); else lead.push(l);
  });
  return { lead: lead.filter((x) => typeof x === "string"), cards, steps };
}

export function parseSolutionContent(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const nodes = [...doc.body.childNodes].filter((n) => n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim()));
  const sections = [{ title: null, nodes: [] }];
  nodes.forEach((n) => { if (n.nodeType === 1 && n.tagName === "H2") sections.push({ title: n.textContent.trim(), nodes: [] }); else sections[sections.length - 1].nodes.push(n); });
  return sections.map((s, idx) => {
    const els = s.nodes.filter((n) => n.nodeType === 1);
    const h3s = els.filter((n) => n.tagName === "H3").length;
    if (h3s >= 2) {
      const guides = []; let img = null; let imgAlt = "";
      els.forEach((n) => {
        if (n.tagName === "IMG") { img = n.getAttribute("src"); imgAlt = n.getAttribute("alt") || ""; }
        else if (n.tagName === "H3") guides.push({ title: n.textContent.trim(), img, imgAlt, text: "", href: null });
        else if (guides.length && n.tagName === "P") guides[guides.length - 1].text += n.innerHTML;
        else if (guides.length && n.tagName === "A") { guides[guides.length - 1].href = n.getAttribute("href"); guides[guides.length - 1].cta = n.textContent.trim(); }
      });
      return { kind: "guides", title: s.title, guides, idx };
    }
    const imgEl = els.find((n) => n.tagName === "IMG");
    const image = imgEl?.getAttribute("src") || null;
    const imageAlt = imgEl?.getAttribute("alt") || "";
    const html2 = els.filter((n) => !["IMG", "H1"].includes(n.tagName)).map((n) => (n.tagName === "P" ? n.innerHTML : n.outerHTML)).join("<br>");
    const { lead, cards, steps } = parseLines(html2);
    return { kind: cards.length >= 2 ? "cards" : steps.length >= 3 ? "steps" : "prose", title: s.title, image, imageAlt, lead, cards, steps, outro: [], idx };
  });
}
